import React from 'react'

import { Button as HubButton } from '@hub/button'
import { Stack as HubStack } from '@hub/stack'
import {
  forwardRef,
  HubStyleObject,
  StandardSizes,
} from '@hub/design-system-base'

type ButtonProps = {
  isFullWidth?: boolean
  sx?: HubStyleObject
}

export const Button = forwardRef<ButtonProps, typeof HubButton>(
  ({ isFullWidth = false, children, sx, ...props }, ref) => {
    return (
      <HubButton
        ref={ref}
        colorScheme={'licorice'}
        width={isFullWidth ? '100%' : { base: '100%', md: 'auto' }}
        height={{ base: '48px', md: '40px' }}
        sx={{
          _disabled: {
            cursor: 'not-allowed',
            opacity: '50%',
          },
          ...sx,
        }}
        {...props}
      >
        {children}
      </HubButton>
    )
  }
)

type ButtonLinkProps = {
  isDisabled?: boolean
  sx?: HubStyleObject
}

export const ButtonLink = forwardRef<ButtonLinkProps, typeof HubButton>(
  ({ children, isDisabled = false, sx, ...props }, ref) => {
    return (
      <HubButton
        ref={ref}
        colorScheme={isDisabled ? 'ghost' : 'licorice'}
        variant={'link'}
        height={'unset'}
        padding={'unset'}
        isDisabled={isDisabled}
        sx={{
          textDecoration: 'underline',
          textTransform: 'none',
          fontWeight: 'normal',
          _disabled: {
            cursor: 'not-allowed',
            textDecoration: 'none',
          },
          ...sx,
        }}
        {...props}
      >
        {children}
      </HubButton>
    )
  }
)

type ButtonStackProps = {
  widthDesktop?: StandardSizes
}

export const ButtonStack = forwardRef<ButtonStackProps, typeof HubStack>(
  ({ children, widthDesktop = '180px', ...props }, ref) => (
    <HubStack
      ref={ref}
      width={{ base: '100%', md: widthDesktop }}
      gap={'spacing-lg'}
      {...props}
    >
      {children}
    </HubStack>
  )
)
